import React, { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import type AdvancedFilter from 'talent_matching/components/filters/advanced_filter';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.advanced_filters');

type Props = {
  filter: AdvancedFilter;
  onValueChange: (newValue: string | Item | Item[] | null) => void;
};

const NumberFilter = ({ filter, onValueChange }: Props) => {
  const [minValue, maxValue] = ((filter.value as string) || '').split(':');
  const initialValue = minValue || maxValue || '';
  const [numberValue, setNumberValue] = useState(initialValue);

  const updateFilterValue = (newValue: string) => {
    switch (filter.operator?.value) {
      case 'equal_to':
        onValueChange(`${newValue}:${newValue}`);
        break;
      case 'greater_than':
        onValueChange(`${newValue}:`);
        break;
      case 'less_than':
        onValueChange(`:${newValue}`);
        break;
    }
  };

  useDebounce(
    () => {
      updateFilterValue(numberValue);
    },
    500,
    [numberValue]
  );

  useEffect(() => {
    updateFilterValue(numberValue);
  }, [filter.operator?.value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TextInput
      ariaLabel={t('value')}
      placeholder={t('value')}
      value={numberValue}
      onChange={(e) => setNumberValue(e.target.value)}
      type="number"
    />
  );
};

export default NumberFilter;
